import React, { useEffect } from "react";
import "./DeliveryPolicyBottomSheet.css";

const DeliveryPolicyBottomSheet = ({ isOpen, onClose }) => {
  // Prevent scrolling on body when bottom sheet is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  return (
    <>
      <div
        className={`delivery-overlay ${isOpen ? "show" : ""}`}
        onClick={onClose}
      ></div>
      <div className={`delivery-bottom-sheet ${isOpen ? "show" : ""}`}>
        <div className="delivery-sheet-header">
          <div className="delivery-drag-handle" onClick={onClose}></div>
          <button className="delivery-close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="delivery-sheet-content">
          <div className="delivery-header-section">
            <h1 className="delivery-title delivery-font-heading">
              Delivery Policy
            </h1>
          </div>

          <div className="delivery-section">
            <h3 className="delivery-font-heading">DELIVERY AREAS & CHARGES </h3>
            <p>
              We deliver across selected UK locations. Delivery charges depend
                          on: ● Your postcode
                          ● The size/weight of your order
                          ● Delivery
              speed Free delivery may be available for orders above a minimum
              spend (shown during checkout).{" "}
            </p>
          </div>

          <div className="delivery-section">
            <h3 className="delivery-font-heading">DELIVERY TIMEFRAMES</h3>
            <p>
            We aim to process all orders within 24 hours. 
            </p>
            <ul>
              <li>
                <strong>Standard Delivery:</strong> Delivered within 2-3
               working days .
              </li>
              <li>
                <strong>Express Delivery:</strong>  24-hour delivery (selected postcodes).
              </li>
              <li>
                <strong>Same-Day Delivery:</strong> Available for local customers placing orders before cutoff times 
              </li>
            </ul>
          </div>

          <div className="delivery-section">
            <h3 className="delivery-font-heading">ORDER TRACKING</h3>
            <p>
              Once your order has been dispatched, you will receive an SMS and
              an email with the tracking link. You can track the live status of
              your order directly from your account dashboard or through our
              courier partner's website.
            </p>
          </div>

          <div className="delivery-section">
            <h3 className="delivery-font-heading">MISSED DELIVERIES</h3>
            <p>
             If you miss a delivery: 
● Our courier will attempt redelivery up to two more times 
● After three failed attempts, the parcel returns to our store/warehouse 
● Refunds (for prepaid orders) will be issued minus delivery fees 
            </p>
          </div>

          <div className="delivery-section">
            <h3 className="delivery-font-heading">
              DAMAGED OR INCORRECT ITEMS
            </h3>
            <p>
              If you receive a package that is damaged, tampered with, or
              contains incorrect items, please do not accept the delivery.
              Contact our customer support immediately at{" "}
              <strong>aarohfood@gmail.com</strong> with photos of the damaged
              package, and we will arrange a replacement or refund.
            </p>
          </div>

          <div className="delivery-section">
            <h3 className="delivery-font-heading">INTERNATIONAL SHIPPING</h3>
            <p>
             We currently do not offer delivery outside the UK. 
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeliveryPolicyBottomSheet;
